import React, {useMemo} from 'react';
import { Box, Typography } from '@mui/material';
import ResponsiveNav from '../components/navigation/navigation';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
// import GiftSubHero from '../components/SubHero/SubHero';
import 'leaflet/dist/leaflet.css';
import ProductOrder from '../components/ProductOrder/ProductOrder';
import MoreItems from '../components/MoreItems/MoreItems';
import { useGet } from '../hooks/useApi';
import { useLocation } from 'react-router-dom';

const Tracking = () => {
  const location = useLocation(); // Get current location (including query params)
  const queryParams = new URLSearchParams(location.search); // Create URLSearchParams object
  const CurrentOrderId = queryParams.get('trackingId');
  const { 
          data: giftData, 
        
        } = useGet('/api/GiftItems/get-all-gift-Items');
    const giftItems = useMemo(() => giftData?.data || [], [giftData]);
    const MoreGiftsData = giftItems?.filter((item)=>item?.categoryName.toLowerCase().includes('for him'))
const { data: validateCustomer} = useGet('/api/GiftItems/validate-Customer');
    const customerId = validateCustomer?.data.userEmail
    console.log(customerId)
const { 
    data: giftOrderHistory, 
  
  } = useGet(`api/GiftItemOrders/order-history?userEmail=${customerId}`);
  const giftOrderItems = useMemo(() => giftOrderHistory?.data || [], [giftOrderHistory]);
  console.log(giftOrderItems)

  const orderItem = giftOrderItems.filter((item)=>item.orderId === CurrentOrderId)
  console.log(orderItem)
    const position = [6.5244, 3.3792];
    const breadcrumbItems = [
        { label: 'Home', link: '/' },
        { label: 'Track Order', link: '/product/tracking' },
      ];
      
  return (
    <Box sx={{}}>
        <ResponsiveNav breadcrumbItems={breadcrumbItems} searchValue="" onSearchChange={() => {}} searchPlaceholder="Search..." />
        <Box>
            <Typography variant='h3' sx={{color:'rgba(86, 4, 246, 1)', my:2, fontSize:{xs:'1.5rem', md:'3rem'}, fontFamily: theme=> theme.typography.bigText,}}>
                Track your Order
            </Typography>
            <Typography sx={{fontSize:'.8rem', my:2, color:'rgba(18, 18, 18, 0.8)', fontFamily: theme=> theme.typography.smallText,}}>
                Stay updated on your order's journey. From processing to delivery, we’ve got you covered every step of the way.
            </Typography>
        </Box>
        <Box sx={{display:{xs:'block', md:'flex'}, justifyContent:'space-between', gap:6, height:{xs:'100%', md:'130vh'}, overflowY:'auto', my:8}}>
            <Box sx={{height:{xs:'80vh', md:'130vh'}, width:{xs:'100%', md:'50%'}, position:'relative', display:'flex', flexDirection:'column', justifyContent:'space-between', mb:{xs:4, md:0}}}>
            <MapContainer center={position} zoom={12} style={{ height: '100%', width: '100%', borderRadius:'16px' }} className='map-item'>
            <TileLayer
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            />
            <Marker position={position}>
              <Popup>FarmSwift Location</Popup>
            </Marker>
          </MapContainer>
            </Box>
            <Box sx={{borderRadius:'24px', border:'1px solid rgba(238, 230, 254, 1)', p:2, height:'100%', width:{xs:'100%', md:'50%'}}}>
                <ProductOrder title={'Luxury Flower Bouquet'} price={'₦10,000'} orderItem={orderItem[0]}/>
            </Box>
        </Box>
        {/* <GiftSubHero/> */}
        <MoreItems title={`Gift ${'For Him'}`} moreGifts={MoreGiftsData}/>
    </Box>
  )
}

export default Tracking